/*jshint esversion: 6 */

// Libraries ========================================================= *
// Bootstrap
import './Libs/bootstrap-setup.js';
// EQCSS (Element Queries)
import 'eqcss';

// Initialize Tooltips
$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover focus'
    }).on('touchstart mouseenter', function () {
        $(this).tooltip('show');
    }).on('touchend mouseleave', function () {
        $(this).tooltip('hide');
    });
});